import React from 'react';
import { Box } from '@fiverr-private/theme';
import { Container, Stack } from '@fiverr-private/layout_components';
import { Typography } from '@fiverr-private/typography';
import { ErrorCircleSolidIcon } from '@fiverr-private/visuals';
import { Button } from '@fiverr-private/button';
import { appTranslate } from '../../i18n';

interface StatusMessageProps {
    isLoading: boolean;
    handleSubmit: () => Promise<void>;
}

export const StatusMessage = ({ isLoading, handleSubmit }: StatusMessageProps) => (
    <Container backgroundColor="yellow_100">
        <Box
            boxSizing="borderBox"
            maxWidth="1400px"
            display="flex"
            direction={{ default: 'column', sm: 'row' }}
            alignItems={{ default: 'flexStart', sm: 'center' }}
            justifyContent="spaceBetween"
            gap="3"
            margin="auto"
            paddingY="4"
            paddingX={{ default: '6', sm: '8' }}
        >
            <Stack direction="row" alignItems="center" gap="3">
                <Container display="flex" flexShrink="0">
                    <ErrorCircleSolidIcon color="grey_1200" />
                </Container>
                <Typography fontWeight="bold" color="bodyPrimary">
                    {appTranslate<string>('message.confirm_email')}
                </Typography>
            </Stack>
            <Container flexShrink="0" paddingLeft={{ default: '7', sm: '0' }}>
                <Button onClick={handleSubmit} loading={isLoading}>
                    {appTranslate<string>('message.confirm_email_cta')}
                </Button>
            </Container>
        </Box>
    </Container>
);
